import {frameworkReelGridContainer} from "../../../core/components/reelgridcontainer/configuration/reelgridcontainerconfiguration";
import {configGame} from "../../../data/config";

frameworkReelGridContainer.data = {
    "REEL_COLUMN": configGame.REEL_COLUMN,
    "REEL_WIDTH": configGame.REEL_WIDTH,
    "REEL_ROWS": configGame.REEL_ROWS,
    "REEL_GAP": configGame.REEL_GAP,
    "SYMBOL_WIDTH": configGame.SYMBOL_WIDTH,
    "SYMBOL_HEIGHT": configGame.SYMBOL_HEIGHT,
    "REEL_CONTAINER_X": configGame.REEL_CONTAINER_X,
    "REEL_CONTAINER_Y": configGame.REEL_CONTAINER_Y,
    "REEL_HEIGHT": configGame.REEL_HEIGHT,
    "IS_STICKY_WILD_PRESENT": false,
    child: []
}